import axios from '@/libs/api.request'
// 加密
export const ossSecret = data => {
  return axios.request({
    url: '/oss/secret/access',
    data,
    method: 'POST'
  })
}
// 公开
export const ossOpen = data => {
  return axios.request({
    url: '/oss/open/access',
    data,
    method: 'POST'
  })
}
// 加密下载
// 参数 dir
export const ossSecretLink = data => {
  return axios.request({
    url: '/oss/secret/link',
    data,
    method: 'POST'
  })
}
// 加密
export const ossSecretUgd = data => {
  return axios.request({
    url: '/ugd/oss/secret/access',
    data,
    method: 'POST'
  })
}
// 公开
export const ossOpenUgd = data => {
  return axios.request({
    url: '/ugd/oss/open/access',
    data,
    method: 'POST'
  })
}
// 加密下载
// 参数 dir
export const ossSecretLinkUgd = data => {
  return axios.request({
    url: '/ugd/oss/secret/link',
    data,
    method: 'POST'
  })
}
// filename
// url
export const downFile = data => {
  axios
    .request({
      url: data.url,
      method: 'GET',
      responseType: 'blob'
    })
    .then(res => {
      let url = window.URL.createObjectURL(
        new Blob([res], {
          type: 'application/msword'
        })
      )
      let link = document.createElement('a')
      link.href = url
      link.setAttribute('download', data.filename)
      link.click()
    })
}
